import React, { useState, useContext } from 'react';
import styled from 'styled-components';
import { FiChevronRight } from 'react-icons/fi';
import { useMutation } from 'react-query';
// import { AiFillEye } from 'react-icons/ai';
import { BsCheckLg } from 'react-icons/bs';
import { MdModeEdit, MdSquare } from 'react-icons/md';
import { CredusButton, CredusText, color } from 'ui';

import { DivProps, BulletProps } from './TestReUpload';
import PublishTestTable from './tables/PublishTestTable';
import TestUploadSuccess from './modals/TestUploadSuccess';
import testApi from '../../../../api/test';
import { TestContext } from '../../../../contexts/TestContext';

interface PublishTestProps {
  setConfigureTest: React.Dispatch<React.SetStateAction<boolean>>;
  setPublishTest: React.Dispatch<React.SetStateAction<boolean>>;
}

const PublishTest = ({
  setConfigureTest,
  setPublishTest,
}: PublishTestProps) => {
  const [showSuccess, setShowSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const { testData, testId, testCategory } = useContext(TestContext);
  const {
    date,
    time,
    timeZone,
    duration,
    maxScore,
    passMark,
    passMarkUnit,
    maxAttempt,
    questions,
  } = testData;

  const { mutate } = useMutation(testApi.publishTest, {
    onMutate: () => setLoading(true),
    onSuccess: () => {
      setLoading(false);
      setShowSuccess(true);
    },
    onError: (error) => {
      setLoading(false);
      throw error;
    },
  });
  const handlePublish = () => {
    mutate([testId, testData]);
  };

  const handleEdit = () => {
    setConfigureTest(true);
  };

  return (
    <Container>
      {showSuccess && (
        <TestUploadSuccess
          showSuccess={showSuccess}
          setShowSuccess={setShowSuccess}
          setPublishTest={setPublishTest}
        />
      )}
      <Header>
        <Div>
          <BulletDiv>
            <Bullet
              background={color.white}
              border={`1px solid ${color.primary}`}
            >
              <BsCheckLg color={color.primary} />
            </Bullet>
            <CredusText size="md">Upload</CredusText>
          </BulletDiv>
          <FiChevronRight color="#7f7f7f" />
          <BulletDiv>
            <Bullet
              background={color.white}
              border={`1px solid ${color.primary}`}
            >
              <BsCheckLg color={color.primary} />
            </Bullet>
            <CredusText size="md">Configure</CredusText>
          </BulletDiv>
          <FiChevronRight color="#7f7f7f" />
          <BulletDiv>
            <Bullet background={color.primary}>
              <CredusText size="xs" color={color.white}>
                3
              </CredusText>
            </Bullet>
            <CredusText size="md">Review & Publish</CredusText>
          </BulletDiv>
        </Div>
        {/* <Div>
          <AiFillEye />
          <CredusText size="md">Preview</CredusText>
        </Div> */}
      </Header>

      <SubHeader>
        <CredusText size="md">
          Test: <strong>{testCategory}</strong>
        </CredusText>

        <CredusText size="md">
          Status: <strong> In progress</strong>
        </CredusText>
      </SubHeader>
      <div>
        <CredusText size="xl" weight="medium">
          Review Test Configuration
        </CredusText>
        <Configuration>
          <EditDiv onClick={handleEdit}>
            <MdModeEdit color={'#000'} />
            <CredusText size="sm" weight="bold">
              Edit
            </CredusText>
          </EditDiv>
          <DetailDiv>
            <CredusText size="lg" weight="medium">
              Date:
            </CredusText>
            <CredusText size="lg" weight="medium">
              Time:
            </CredusText>
            <CredusText size="lg" weight="medium">
              Test Duration:
            </CredusText>
            <CredusText size="lg" weight="medium">
              Time Zone:
            </CredusText>
            <CredusText size="lg" weight="medium">
              Total Test Points:
            </CredusText>
            <CredusText size="lg" weight="medium">
              Pass Mark:
            </CredusText>
            <CredusText size="lg" weight="medium">
              No of Attempts:
            </CredusText>
          </DetailDiv>
          <DetailDiv>
            <CredusText size="lg" weight="bold">
              {date}
            </CredusText>
            <CredusText size="lg" weight="bold">
              {time}
            </CredusText>
            <CredusText size="lg" weight="bold">
              {duration}
            </CredusText>
            <CredusText size="lg" weight="bold">
              {timeZone}
            </CredusText>
            <CredusText size="lg" weight="bold">
              {maxScore}
              {passMarkUnit == 1 ? 'pts' : '%'}
            </CredusText>
            <CredusText size="lg" weight="bold">
              {passMark}
              {passMarkUnit == 1 ? 'pts' : '%'}
            </CredusText>
            <CredusText size="lg" weight="bold">
              {maxAttempt}
            </CredusText>
          </DetailDiv>
        </Configuration>
      </div>
      <CredusText size="xl" weight="medium">
        Question
      </CredusText>
      <Div width="100%" justify="flex-end">
        <Div gap=".5rem">
          <MdSquare color="#0A8B38" />
          <CredusText size="sm">Correct</CredusText>
        </Div>
        <Div gap=".3rem">
          <MdSquare color="#FDC453" />
          <CredusText size="sm">Wrong</CredusText>
        </Div>
      </Div>
      <PublishTestTable questions={questions} />
      <BtnDiv>
        <CredusButton variant="secondary">Return</CredusButton>
        <CredusButton onClick={handlePublish} disabled={loading}>
          {loading ? 'Loading' : 'Publish'}
        </CredusButton>
      </BtnDiv>
    </Container>
  );
};

export default PublishTest;
const Container = styled.div`
  background: ${color.white};
  padding: 2rem 1rem;
`;
const Header = styled.div`
  display: flex;
  justify-content: space-between;
`;

const Div = styled.div<DivProps>`
  display: flex;
  gap: ${({ gap }) => (gap ? gap : '1rem')};
  justify-content: ${({ justify }) => justify};
  width: ${({ width }) => width};
  align-items: center;
  margin-bottom: 0.5rem;
`;

const BulletDiv = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;
`;

const Bullet = styled.div<BulletProps>`
  height: 28px;
  width: 28px;
  border-radius: 50%;
  background: ${(props) => props.background};
  color: ${(props) => props.color};
  border: ${(props) => props.border};
  display: flex;
  align-items: center;
  justify-content: center;
`;
const SubHeader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 3rem;
  padding-top: 3.5rem;
  width: 100%;
  padding-bottom: 1rem;
  margin-bottom: 1.5rem;
  border-bottom: 1px solid rgba(0, 9, 41, 0.15);
`;

const Configuration = styled.div`
  position: relative;
  width: 70%;
  background: #fff2f1;
  min-height: 328px;
  margin-top: 1rem;
  margin-bottom: 2rem;
  padding: 35px 46px;
  box-sizing: border-box;
  display: flex;
  gap: 2rem;
`;

const EditDiv = styled.div`
  width: 94px;
  height: 58px;
  border-radius: 8px;
  background: #ffd3cd;
  display: flex;
  justify-content: center;
  gap: 0.5rem;
  align-items: center;
  position: absolute;
  top: 21px;
  right: 37px;
  cursor: pointer;
`;

const DetailDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
`;

const BtnDiv = styled.div`
  width: 100%;
  display: flex;
  gap: 1rem;
  padding: 3rem;
  justify-content: flex-end;
`;
